module.exports = __webpack_public_path__ + "static/media/pricing.08dc6018.png";